module.exports = __webpack_public_path__ + "img/677-146cb0.png";